/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';


export interface PraticaEsercenteSummaryDTO { 
    id?: string;
    codice_pratica?: string;
    stato_richiesta?: RichiestaPraticaEsercenteStatus;
    tipo_pratica_id?: string;
    tipo_pratica_titolo?: string;
    ragione_sociale?: string;
    partita_iva?: string;
    pec?: string;
    timestamp_richiesta?: string;
}



